import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Container, Module, Slide, Quiz, Video } from 'components/pages/certifications/framework'
import { TRAINING_CERTS } from 'util/constants'
import styled from 'styled-components'
import firstImage from 'images/training/onboarding/01-sheila-and-hatchback@2x.png'
import secondImage from 'images/training/onboarding/12-great-job@2x.png'
import { Overline, H4, H5, Subtitle2, Body2 } from 'components/layout/text'
import Spacer from 'components/misc/Spacer'
import { BasicButton } from 'components/layout/buttons'
import { driveNeedsSelector } from 'selectors'
import { getProfile } from 'actions/profile'
import thirdImage from 'images/training/onboarding/img-5060@2x.png'
import { Button } from 'roadie-ui'
import CommittedCapacity from '../CommittedCapacity/CommittedCapacityPage'
import { FeatureFlag } from 'Optimizely'
import { LocalizedText, useLocalization } from 'localization'
const WideImg = styled.img`
  width: 320px;
  height: auto;
  margin: 0 auto;
  align-self: flex-start;
`
const ImgContainer = styled.div`
  width: 100%;
  display: flex;
`
const OnboardingVideo = ({ id, h }) => (
  <Video
    src={`https://player.vimeo.com/video/${id}?h=${h}&autoplay=0&muted=1&autopause=0&controls=0&playsinline=true&loop=1`}
    height="490"
  />
)
const OnboardingPage = (props) => {
  const { t } = useLocalization()
  const { blocksOn } = props
  const dispatch = useDispatch()
  const [showBlocks, setShowBlocks] = useState(false)
  const handleShowMeGigs = React.useCallback(() => {
    dispatch(getProfile())
  }, [dispatch])
  const handleShowBlocks = React.useCallback(() => {
    setShowBlocks(true)
  }, [])
  if (showBlocks) {
    return <CommittedCapacity />
  }
  return (
    <Container title={t('dweb_certifications_onboarding_onboarding_driver_onboarding')}>
      <Module certification={TRAINING_CERTS.ONBOARDING}>
        <Slide>
          <ImgContainer>
            <WideImg src={firstImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <Overline weight="500" color="primaryBase">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_thanks_signing_up" />
          </Overline>
          <Spacer height=".8rem" />
          <H4>
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_welcome_roadie" />
          </H4>
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_first_lets_make_sure_know_way_around_app" />
          </Body2>
        </Slide>

        <Slide>
          <H5 weight="600">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_browse_gigs_map" />
          </H5>
          <Spacer height=".8rem" />
          <Subtitle2 weight="bold">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_find_opportunities_near" />
          </Subtitle2>
          <Spacer height=".8rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_can_see_available_gigs_by_checking_map_tap" />
          </Body2>
          <Spacer height="3.2rem" />
          <OnboardingVideo id="632074314" h="9cc6649c8b" />
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <H5 weight="600">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_viewing_gig_details" />
          </H5>
          <Spacer height=".8rem" />
          <Subtitle2 weight="bold">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_learn_more_about_requirements" />
          </Subtitle2>
          <Spacer height=".8rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_gig_details_intro" />
          </Body2>
          <Spacer height="3.2rem" />
          <OnboardingVideo id="632074315" h="d20f0d2c35" />
          <Spacer height="3.2rem" />
          <Quiz
            questionKey="dweb_certifications_onboarding_quiz_q1_question"
            descriptionKey="dweb_certifications_onboarding_quiz_q1_description"
            options={[
              {
                textKey: 'dweb_certifications_onboarding_quiz_q1_option_1',
                value: '1',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q1_option_2',
                value: '2',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q1_option_3',
                value: '3',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q1_option_4',
                value: '4',
                isCorrect: true,
              },
            ]}
          />
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <H5 weight="600">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_hitting_road_pickup" />
          </H5>
          <Spacer height=".8rem" />
          <Subtitle2 weight="bold">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_heading_pickup" />
          </Subtitle2>
          <Spacer height=".8rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_start_accepted_gig" />
          </Body2>
          <Spacer height=".8rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_pickup_steps" />
          </Body2>
          <Spacer height="3.2rem" />
          <OnboardingVideo id="632074210" h="c7f341023b" />
          <Spacer height="3.2rem" />
          <Quiz
            questionKey="dweb_certifications_onboarding_quiz_q2_question"
            descriptionKey="dweb_certifications_onboarding_quiz_q2_description"
            options={[
              {
                textKey: 'dweb_certifications_onboarding_quiz_q2_option_1',
                value: '1',
                isCorrect: true,
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q2_option_2',
                value: '2',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q2_option_3',
                value: '3',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q2_option_4',
                value: '4',
              },
            ]}
          />
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <H5 weight="600">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_hitting_road_dropoff" />
          </H5>
          <Spacer height=".8rem" />
          <Subtitle2 weight="bold">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_completing_delivery" />
          </Subtitle2>
          <Spacer height=".8rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_delivery_steps" />
          </Body2>
          <Spacer height="2.4rem" />
          <Overline color="primaryBase" weight="bold">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_pro_tip" />
          </Overline>
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_photo_tips" />
          </Body2>
          <Spacer height="3.2rem" />
          <ImgContainer>
            <WideImg src={thirdImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <Quiz
            questionKey="dweb_certifications_onboarding_quiz_q3_question"
            descriptionKey="dweb_certifications_onboarding_quiz_q3_description"
            options={[
              {
                textKey: 'dweb_certifications_onboarding_quiz_q3_option_1',
                value: '1',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q3_option_2',
                value: '2',
              },
              {
                textKey: 'dweb_certifications_onboarding_quiz_q3_option_3',
                value: '3',
                isCorrect: true,
              },
            ]}
          />
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <H5 weight="600">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_get_help" />
          </H5>
          <Spacer height=".8rem" />
          <Subtitle2 weight="bold">
            <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_were_here_when_need_us" />
          </Subtitle2>
          <Spacer height=".8rem" />
          <Body2>
            {/* eslint-disable-next-line no-irregular-whitespace */}
            <LocalizedText translationKey="dweb_certifications_onboarding_get_help_intro" />
          </Body2>
          <Spacer height="2.4rem" />
          <Body2>
            <LocalizedText translationKey="dweb_certifications_onboarding_text_support_tip" />
          </Body2>
          <Spacer height="3.2rem" />
          <OnboardingVideo id="632074143" h="7378ff810e" />
          <Spacer height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <WideImg src={secondImage} />
          </ImgContainer>
          <Spacer height="3.2rem" />
          <H4 weight="bold">
            <LocalizedText translationKey="dweb_certifications_committed_capacity_nice_job" />
          </H4>
          {blocksOn ? (
            <div>
              <Body2>
                <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_youve_completed_our_app_walkthrough" />
              </Body2>
              <Spacer height="2.2rem" />
              <Body2>
                <LocalizedText translationKey="dweb_certifications_onboarding_scheduled_blocks_second_walkthrough_prompt" />
              </Body2>
            </div>
          ) : (
            <Body2>
              <LocalizedText translationKey="dweb_certifications_onboarding_completion_next_steps" />
            </Body2>
          )}
          <Spacer height="12rem" />
          {blocksOn ? (
            <Button.Secondary $width="100%" onClick={handleShowBlocks}>
              <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_learn_about_blocks" />
            </Button.Secondary>
          ) : !props.registered ? (
            <BasicButton mode="primary" onClick={handleShowMeGigs}>
              <LocalizedText translationKey="dweb_certifications_onboarding_onboarding_show_me_gigs" />
            </BasicButton>
          ) : null}
        </Slide>
      </Module>
    </Container>
  )
}
const FFOnboarding = (props) => {
  return (
    <FeatureFlag feature="onboarding_roadie_blocks_link_enabled">
      {(enabled) => <OnboardingPage {...props} blocksOn={enabled} />}
    </FeatureFlag>
  )
}
export default connect(driveNeedsSelector)(FFOnboarding)
